import { Component, ViewEncapsulation, Input, AfterViewInit, ElementRef, OnInit, ViewChild, QueryList, ViewChildren } from "@angular/core";


@Component({
  selector: 'app-read-more',
  templateUrl: './read-more.component.html',
  styleUrls: ['./read-more.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReadMoreComponent implements OnInit{

  @Input() dataLength: number;
  @Input() text: string;
  @Input() keyWord: string;
  @Input() iduser: string;
  @Input() type: string;
  @Input() isTransfered: boolean;
  formatedText = null;
  textWithLink = null;
  public isCollapsed: boolean = true;
  public isCollapsable: boolean = false;
  id = null;

  //@ViewChild('textContainer', {static: true}) textContainer!: ElementRef;
  //@ViewChildren('readMore') myDivs!: QueryList<ElementRef>;
  originalText: string = '';
  truncatedText: string = '';
  isTruncated: boolean = false;
  private readonly charactersToRemove = 30;
  
  constructor(private elementRef: ElementRef) {
  }

  isTextLongOrContainsThreeNewLines(): boolean {
    if(this.type == 'comment' || this.type == 'willcomment'){
      return (this.text.length > 110 ) || ((this.text.match(/\n/g) || []).length >= 1);
    } else return this.text.length > this.dataLength || (this.text.match(/\n/g) || []).length >= 4;
  }

  ngOnInit(){
    this.id = JSON.parse(localStorage.getItem('currentUser'))['id'];
    var largeurEcran = window.innerWidth;
    const averageCharWidth = 11.4;
    const averageCharcomWidth = 9.6;
    var msgwidth = largeurEcran * 0.32;
    var commentwidth = largeurEcran * 0.75;
    var msgCharacters = Math.floor(msgwidth / averageCharWidth) * 4;
    var commentCharacters = Math.floor(commentwidth / averageCharcomWidth);
    this.dataLength = msgCharacters;
    let baseText = this.text;
    if(this.isTransfered){
      baseText = "Message transféré : "+this.text;
    }
    //this.formatedText = this.truncate(this.text, this.dataLength);
    baseText = this.text.replace(/(http?s:\/\/[^\s"'<>]+)/g, "<a href='$1' target='__blank'>$1</a>");
    this.formatedText = baseText;
    this.textWithLink = this.formatedText;
    //--------
    //this.formatedText = this.fullTextWithLink(this.text);
    //this.textWithLink = this.formatedText;
  }

  highlightKeyword(text: string, keyword: string): string {
    if (!keyword) return text;
    const regex = new RegExp(keyword, 'gi');
    return text.replace(regex, match => `<span style="background-color: yellow;" class="highlighted">${match}</span>`);
  }


  truncate(value: string, limit = 25, completeWords = false, ellipsis = '...') {

    if (completeWords) {
      limit = value.substr(0, limit).lastIndexOf(' ');
    }

    // Finds starting and ending positions of quoted text
    // in double or single quotes with escape char support like \" \'
    var match;
    var patt = /(http?s:\/\/[^\s]+)/g;

    while (match = patt.exec(value)) {
      limit += patt.lastIndex - match.index;
    }


    let val =  value.length > limit ? value.substr(0, limit) + ellipsis : value;
    return val.replace(/(http?s:\/\/[^\s]+)/g, "<a href='$1' target='__blank'>$1</a>");

  }

  fullTextWithLink(value: string) {
    return value.replace(/(http?s:\/\/[^\s]+)/g, "<a href='$1' target='__blank'>$1</a>");
  }
  

}
